<template>
    <div class="pt-16 lg:pt-0">
        <div class="fixed z-100 bg-gray-100 inset-x-0 top-0 border-b-2 border-gray-200 lg:border-b-0 lg:static flex items-center">
            <div class="w-full max-w-screen-xl relative mx-auto px-6">
                <div class="lg:border-b-2 lg:border-gray-200 h-16 flex flex-col justify-center">
                    <div class="flex items-center -mx-6">
                        <div class="lg:w-1/4 xl:w-1/5 pl-6 flex items-center">
                            <a href="/" class="flex lg:mr-4">
                                <img class="md:mt-4 hidden mt-1 mr-1 h-6 w-auto"
                                     :src="require('@/assets/img/logos/logo.png')"
                                     alt="Brandfi logo"/>
                                <h2 class="text-3xl sm:text-4xl text-teal-600 md:text-5xl font-bold xl:text-4xl font-light leading-tight">
                                    BRAND-fi
                                </h2> 
                            </a>
                        </div>
                        <div class="flex flex-grow lg:w-3/4 xl:w-4/5">

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full max-w-screen-xl relative mx-auto pt-16 pb-40 md:pb-24">
            <div class="xl:flex">
                <div class="hidden md:block xl:w-3/4 text-left md:text-center xl:text-left max-w-2xl md:max-w-3xl ">
                    <!-- <h1 class="text-3xl sm:text-4xl md:text-5xl xl:text-4xl font-light leading-tight">BRAND-fi <span
                            class="sm:block text-teal-500 font-normal">Connected Digital Experience.</span>
                    </h1> -->
                    <!-- <p class="mt-6 leading-relaxed sm:text-lg md:text-xl xl:text-lg text-gray-600">
                        Subscription-based, Engaging cloud-delivered ,Wi-Fi connect,
                        Analytics and Digital Signage solutions
                    </p> -->
                    <div class="flex mt-6 justify-start md:justify-center xl:justify-start">
                        <!-- <a href="/docs/installation"
                           class="rounded-lg px-4 md:px-5 xl:px-4 py-3 md:py-4 xl:py-3 bg-teal-500 hover:bg-teal-600 md:text-lg
                       xl:text-base text-white font-semibold leading-tight shadow-md">Get
                            Started</a>
                        <a href="#what-is-tailwind"
                           class="ml-4 rounded-lg px-4 md:px-5 xl:px-4 py-3 md:py-4 xl:py-3 bg-white hover:bg-gray-200
                        md:text-lg xl:text-base text-gray-800 font-semibold leading-tight shadow-md">Why
                            Brandfi?</a> -->
                    </div>
                </div>
                <div class="md:mt-12 xl:w-1/4 mx-auto  xl:mt-0 px-6 md:px-0">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ForgotPassword',
        props: {
            msg: String
        },
        data() {
            return {
            }
        },
        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
